module.exports = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};


//# sourceMappingURL=ar-AE.main.js.map
